import FormInputText from './../Partials/FormInputText';
import FormInputUpload from './../Partials/FormInputUpload';
import FormInputTextArea from './../Partials/FormInputTextArea';
import MetaColumn from './MetaColumn';
import GeneralForm from './../Forms/GeneralForm';

const JobConditionsPageBuilder = {
    component: GeneralForm,
    options: {
        columns: {
            meta: MetaColumn,
            contents: [
                {
                    field: "heading",
                    partial: {
                        handler: FormInputText,
                        props: {
                            initialValue: (formHandler) => {
                                return formHandler.getArrayInputValue("contents", "heading");
                            },
                            required: true,
                            label: "سرصفحه"
                        }
                    }
                },
                {
                    field: "mobile_image",
                    partial: {
                        handler: FormInputUpload,
                        props: {
                            initialValue: (formHandler) => {
                                return formHandler.getArrayInputValue("contents", "mobile_image");
                            },
                            required: true,
                            label: "عکس موبایل",
                            direction: "ltr"
                        }
                    }
                },
                {
                    field: "desktop_image",
                    partial: {
                        handler: FormInputUpload,
                        props: {
                            initialValue: (formHandler) => {
                                return formHandler.getArrayInputValue("contents", "desktop_image");
                            },
                            required: true,
                            label: "عکس کامپیوتر",
                            direction: "ltr"
                        }
                    }
                },
                {
                    field: "mail",
                    partial: {
                        handler: FormInputText,
                        props: {
                            initialValue: (formHandler) => {
                                return formHandler.getArrayInputValue("contents", "mail");
                            },
                            required: true,
                            label: "ایمیل",
                            direction: "ltr"
                        }
                    }
                },
                {
                    field: "description",
                    partial: {
                        handler: FormInputTextArea,
                        props: {
                            initialValue: (formHandler) => {
                                return formHandler.getArrayInputValue("contents", "description");
                            },
                            required: true,
                            label: "توضیحات",
                            textSize: 7
                        }
                    }
                },
                {
                    field: "jobs",
                    partial: {
                        handler: (props)=> {
                            return props.formHandler.buildArrayInputs("contents", "jobs", "شغل ها", {

                                "thumb": {
                                    partial: {
                                        handler: FormInputUpload,
                                        props: {
                                            required: false,
                                            label: "عکس کوچک"
                                        }
                                    }
                                },
                                "href": {
                                    props: {
                                        style: {direction: "ltr"}
                                    },
                                    label: "لینک"
                                },
                                "title": {
                                    label: "عنوان"
                                },
                                "occupation": {
                                    label: "فرصت شغلی"
                                },
                                "contract_type": {
                                    label: "نوع قرارداد"
                                },

                            })
                        },
                    }
                }
            ]
        }
    }
};

export default JobConditionsPageBuilder;


// WEBPACK FOOTER //
// ./src/containers/Pages/Builders/JobConditionsPageBuilder.js